import {
  CUSTOM_HOSTNAME_REQ,
  CUSTOM_HOSTNAME_SUCCESS,
  CUSTOM_HOSTNAME_ERROR,
  BULK_HOSTNAME_REQ,
  BULK_HOSTNAME_SUCCESS,
  BULK_HOSTNAME_ERROR
} from './agents.type'

import ApiRest from '@/api/api-rest'

const state = {
  customHostnameReqStatus: ''
}

const getters = {
  customHostnameReqStatus: state => state.customHostnameReqStatus
}

// Best Practice - updates state
const mutations = {
  [CUSTOM_HOSTNAME_REQ]: state => {
    state.customHostnameReqStatus = 'loading'
  },
  [CUSTOM_HOSTNAME_SUCCESS]: (state, data) => {
    state.customHostnameReqStatus = 'saved'
  },
  [CUSTOM_HOSTNAME_ERROR]: (state, errMsg) => {
    state.customHostnameReqStatus = 'error'
  }
}

// Best Practice - actions call mutations
// make api call and commit states
const actions = {
  [CUSTOM_HOSTNAME_REQ] (context, agent) {
    return new Promise((resolve, reject) => {
      context.commit(CUSTOM_HOSTNAME_REQ)
      ApiRest()
        .post(`/hostname-map/${agent.agentId}`, {
          customHostname: agent.customHostname,
          criticality: agent.criticality
        })
        .then(({ data }) => {
          context.commit(CUSTOM_HOSTNAME_SUCCESS, data)
          resolve(data)
        })
        .catch(errMsg => {
          context.commit(CUSTOM_HOSTNAME_ERROR, errMsg)
          reject(errMsg)
        })
    })
  },
  [BULK_HOSTNAME_REQ] (context, agents) {
    return new Promise((resolve, reject) => {
      context.commit(CUSTOM_HOSTNAME_REQ)
      // set customHostname to undefined if same as hostname or marked 'UNNAMED' - these are display placeholders
      agents = _.map(agents, agent => {
        if (agent.customHostname === agent.hostname || agent.customHostname === 'UNNAMED') {
          agent.customHostname = undefined
        }
        return agent
      })

      ApiRest()
        .post(`/hostname-map`, {
          hosts: agents
        })
        .then(({ data }) => {
          context.commit(CUSTOM_HOSTNAME_SUCCESS, data)
          resolve(data)
        })
        .catch(errMsg => {
          context.commit(CUSTOM_HOSTNAME_ERROR, errMsg)
          reject(errMsg)
        })
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/agents/hostname.module.js